import { render } from "./SurveyQuestions.vue?vue&type=template&id=423da781"
import script from "./SurveyQuestions.vue?vue&type=script&lang=ts"
export * from "./SurveyQuestions.vue?vue&type=script&lang=ts"
script.render = render

export default script